// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.two-column-card {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 20px auto;
    max-width: 1200px;
}

.two-column-card-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: left;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: calc(50% - 20px); /* Two columns */
    position: relative;
}

.card-cancellation {
    background: linear-gradient(134deg, rgba(255, 255, 255, 1.0) 0%, rgba(219, 234, 254, 1.0) 100%);
    border: 1px solid #4a90e2; /* Light blue border */
}

.card-cancellation-extra {
    background-color: #f0f4ff; /* Light blue */
    border: 1px solid #4a90e2; /* Light blue border */
}

.card-full-liability {
    /* background-color: #4a3fc5; Dark purple */
    background-color: #1E40AF; /* Dark blue */
    color: white;
    border: none;
}

.recommended-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background-color: #5e36ff;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
}

.card-price {
    font-size: 36px;
    font-weight: bold;
    margin: 12px 0;
}

.card-onwards {
    font-size: 16px;
    margin-bottom: 16px;
}

.card-features {
    list-style: none;
    padding: 0;
    margin: 0 0 24px 0;
}

.card-features li {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.card-features li .icon {
    margin-right: 8px;
}

.card-features li.success .icon {
    color: #00c853 !important;
}

.card-features li.failure .icon {
    color: #ff0000;
}

.card-button {
    background-color: #2563EB !important;
    color: white !important;
    padding: 10px 20px;
    border: 2px solid #5e36ff;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
}

.card-full-liability .card-button {
    background-color: white;
    color: #4a3fc5;
    border-color: white;
}

.card-button:hover {
    background-color:#5e36ff !important;
    color: white !important;
    border-color: #5e36ff;
}

.card-button-dark {
    background-color: transparent;
    color: inherit;
    padding: 10px 20px;
    border: 2px solid #5e36ff;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
}

.card-full-liability .card-button-dark {
    background-color: #4a3fc5;
    color: white;
    border-color: white;
}

.card-button-dark:hover {
    background: #5e36ff !important; 
    color: white !important;
    border-color: #5e36ff;
}

.card-full-liability-extra {
    background-color: linear-gradient(134deg, rgba(255, 255, 255, 0.88) 0%, rgba(219, 234, 254, 0.88) 100%);
}

@media (max-width: 768px) {
    .two-column-card {
        flex-direction: column; /* Stack cards vertically on smaller screens */
    }

    .two-column-card-box {
        width: 100%; /* Take full width on mobile */
        margin-bottom: 20px; /* Add some spacing between stacked cards */
    }
}`, "",{"version":3,"sources":["webpack://./src/blocks/TwoColumnCard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,uBAAuB,EAAE,gBAAgB;IACzC,kBAAkB;AACtB;;AAEA;IACI,+FAA+F;IAC/F,yBAAyB,EAAE,sBAAsB;AACrD;;AAEA;IACI,yBAAyB,EAAE,eAAe;IAC1C,yBAAyB,EAAE,sBAAsB;AACrD;;AAEA;IACI,2CAA2C;IAC3C,yBAAyB,EAAE,cAAc;IACzC,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,uGAAuG;AAC3G;;AAEA;IACI;QACI,sBAAsB,EAAE,8CAA8C;IAC1E;;IAEA;QACI,WAAW,EAAE,8BAA8B;QAC3C,mBAAmB,EAAE,2CAA2C;IACpE;AACJ","sourcesContent":[".two-column-card {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin: 20px auto;\n    max-width: 1200px;\n}\n\n.two-column-card-box {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: left;\n    padding: 24px;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    width: calc(50% - 20px); /* Two columns */\n    position: relative;\n}\n\n.card-cancellation {\n    background: linear-gradient(134deg, rgba(255, 255, 255, 1.0) 0%, rgba(219, 234, 254, 1.0) 100%);\n    border: 1px solid #4a90e2; /* Light blue border */\n}\n\n.card-cancellation-extra {\n    background-color: #f0f4ff; /* Light blue */\n    border: 1px solid #4a90e2; /* Light blue border */\n}\n\n.card-full-liability {\n    /* background-color: #4a3fc5; Dark purple */\n    background-color: #1E40AF; /* Dark blue */\n    color: white;\n    border: none;\n}\n\n.recommended-badge {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    background-color: #5e36ff;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.card-price {\n    font-size: 36px;\n    font-weight: bold;\n    margin: 12px 0;\n}\n\n.card-onwards {\n    font-size: 16px;\n    margin-bottom: 16px;\n}\n\n.card-features {\n    list-style: none;\n    padding: 0;\n    margin: 0 0 24px 0;\n}\n\n.card-features li {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.card-features li .icon {\n    margin-right: 8px;\n}\n\n.card-features li.success .icon {\n    color: #00c853 !important;\n}\n\n.card-features li.failure .icon {\n    color: #ff0000;\n}\n\n.card-button {\n    background-color: #2563EB !important;\n    color: white !important;\n    padding: 10px 20px;\n    border: 2px solid #5e36ff;\n    border-radius: 4px;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.card-full-liability .card-button {\n    background-color: white;\n    color: #4a3fc5;\n    border-color: white;\n}\n\n.card-button:hover {\n    background-color:#5e36ff !important;\n    color: white !important;\n    border-color: #5e36ff;\n}\n\n.card-button-dark {\n    background-color: transparent;\n    color: inherit;\n    padding: 10px 20px;\n    border: 2px solid #5e36ff;\n    border-radius: 4px;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.card-full-liability .card-button-dark {\n    background-color: #4a3fc5;\n    color: white;\n    border-color: white;\n}\n\n.card-button-dark:hover {\n    background: #5e36ff !important; \n    color: white !important;\n    border-color: #5e36ff;\n}\n\n.card-full-liability-extra {\n    background-color: linear-gradient(134deg, rgba(255, 255, 255, 0.88) 0%, rgba(219, 234, 254, 0.88) 100%);\n}\n\n@media (max-width: 768px) {\n    .two-column-card {\n        flex-direction: column; /* Stack cards vertically on smaller screens */\n    }\n\n    .two-column-card-box {\n        width: 100%; /* Take full width on mobile */\n        margin-bottom: 20px; /* Add some spacing between stacked cards */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
